export const CART_STEPS_CATEGORIES = {
  OVERVIEW: 'Warenkorb Step1',
  AUTH: 'Warenkorb Step1B',
  ADDRESS: 'Warenkorb Step2',
  PAYMENT: 'Warenkorb Step3',
  CHECKOUT: 'Warenkorb Step4'
} as const;

export const CART_ACTIONS = {
  PAYPAL_EXPRESS: 'paypalExpress',
  DPO: 'DPO',
  CONTINUE_SHOPPING: 'Weiter einkaufen',
  PROCEED_TO_CHECKOUT: 'zur Kasse',
  VOUCHER: 'Gutschein',
  CLICK_DELETE: 'click_delete',
  CONFIRM_DELETE: 'confirm_delete',
  CANCEL_DELETE: 'cancel_delete',
  INCREASE_QUANTITY: 'increase_quantity',
  DECREASE_QUANTITY: 'decrease_quantity',
  CLICK_EDIT: 'click_edit',
  CLICK_COPY: 'click_copy',
  PHONE: 'Telefonnummer',
  NEXT: 'Weiter',
  BACK: 'zurück',
  ADDRESS_VALIDATION: 'Adressvalidierung',
  PAYMENT: 'Payment',
  // leading space is part of the Gatsby event name
  PAYMENT_ALL: ' PaymentAll',
  AGB: 'AGB',
  PRIVACY: 'privacy',
  // not CLICK_EDIT: that one is the overview article edit, this is the checkout summary card link
  EDIT: 'Bearbeiten'
} as const;

export const CART_TRACKING_LABEL = {
  click: 'Klick',
  error: 'Fehler',
  yes: 'ja',
  no: 'nein',
  suggestion: 'Vorschlag',
  input: 'Eingabe'
} as const;

/** Event labels of the "ändern" links on the checkout summary cards (Gatsby: EVENT_DETAIL_CARDS). */
export const CART_CHECKOUT_EDIT_LABEL = {
  shippingAddress: 'Lieferadresse',
  billingAddress: 'Rechnungsadresse',
  payment: 'Zahlart'
} as const;
